import { authImg, logo, textImg } from "assets/images";
import { Button, Input } from "components/form";
import React, { useState } from "react";
import "./Auth.scss";
import { Link } from "react-router-dom";
import { removeErrorFields, validateInput } from "validation";
import { auth } from "validation/schema/auth";
import usePasswordToggle from "hooks/usePasswordToggle";
import { capitalizeFirstWord, validateOnlyNumber } from "utils/commonHelper";
import useButtonLoader from "hooks/useButtonLoader";
import { toastMessage } from "utils/toastMessageHelper";
import { sendVerifyOtp } from "services/auth";
import OTPScreen from "./OTPScreen";
import CustomModal from "components/modals/CustomModal";
import { constant } from "constant/constantValue";
import { useTranslation } from "react-i18next";

const SignUp = () => {
  const [inputType, icon] = usePasswordToggle();

  const { t } = useTranslation();

  // Hook
  const [sendVerifyButtonLoader, setSendVerifyButtonLoader] = useButtonLoader(
    t("REGISTER.createAccount")
  );

  // Set all value
  const [verificationModal, setVerificationModal] = useState(false);
  const [inputData, setInputData] = useState({
    userRole: "researcher",
    isRegister: false,
  });
  const [error, setError] = useState({});

  // close modal
  const closeModal = () => {
    setVerificationModal(false);
  };

  // input validation
  const validation = () => {
    const { errors, status } = validateInput(
      inputData,
      "sendVerifyOtpSchema",
      auth,
      null
    );
    setError(errors);
    return status;
  };

  // Input change handler
  const changeHandler = (event) => {
    const { name, value } = event.target;
    let newValue = value;

    if (name === "mobile") {
      newValue = validateOnlyNumber(value);
    }

    if (["firstName", "lastName"].includes(name)) {
      newValue = capitalizeFirstWord(value);
    }

    if (name === "firstName") {
      const updatedFirstName = newValue.replace(/\s/g, ""); // Remove spaces
      setInputData({ ...inputData, firstName: updatedFirstName });
    } else {
      setInputData({ ...inputData, [name]: newValue });
    }

    setError((prevError) => removeErrorFields(prevError, name));
  };

  // Send Verificaton OTP handler

  const sendVerificationOtpHandler = async (e) => {
    e.preventDefault();
    if (validation()) {
      try {
        setSendVerifyButtonLoader(true);
        const reqData = {
          email: inputData?.email,
          mobile: inputData?.mobile,
          userRole: inputData?.userRole,
          isRegister: inputData?.isRegister,
        };

        // Send verification OTP request
        const { message = "", status } = await sendVerifyOtp(reqData);

        if (status === 200) {
          setVerificationModal(true);
          toastMessage(message, "success", "sendVerifyOtp");
        }
      } catch (e) {
        console.log("error", e);
      } finally {
        setSendVerifyButtonLoader(false);
      }
    }
  };

  return (
    <>
      <div className="auth_page">
        <div className="image_section">
          <Link to={"/"}>
            <img src={logo} alt="logo" className="logo" />
          </Link>
          {/* <img src={authImg} alt="" className="side_img" /> */}
          <img src={textImg} alt="" className="text_img" />
        </div>
        <div className="auth_form">
          <form>
            <div className="form_title">
              <h3>{t("REGISTER.createAnAccount")}</h3>
            </div>
            <div className="form_field">
              <Input
                type="text"
                placeholder={t("REGISTER.enterFirstName")}
                label={t("REGISTER.firstName")}
                name="firstName"
                value={inputData?.firstName}
                onChange={changeHandler}
                error={error?.firstName}
                extraError={error?.firstNameErr}
                maxLength={constant.MAX_INPUT_LENGTH}
              />
            </div>
            <div className="form_field">
              <Input
                type="text"
                placeholder={t("REGISTER.enterLastName")}
                label={t("REGISTER.lastName")}
                name="lastName"
                value={inputData?.lastName}
                onChange={changeHandler}
                error={error?.lastName}
                extraError={error?.lastNameErr}
                maxLength={constant.MAX_INPUT_LENGTH}
              />
            </div>
            <div className="form_title">
              <Input
                type="email"
                placeholder={t("REGISTER.enterBusinessEmail")}
                label={t("REGISTER.businessEmail")}
                name="email"
                value={inputData?.email}
                onChange={changeHandler}
                error={error?.email}
                extraError={error?.emailErr}
                maxLength={320}
              />
              {/* <span
                className="password_icons Verify"
                onClick={() => setVerificationModal(true)}
              >
                Verify
              </span> */}
            </div>
            <div className="form_field has_country_code">
              <Input
                type="text"
                name="mobile"
                label={t("REGISTER.mobileNumber")}
                error={error?.mobile}
                onChange={changeHandler}
                value={inputData?.mobile}
                extraError={error?.mobileErr}
                placeholder={t("REGISTER.enterMobileNumber")}
                maxLength={constant.SIGN_UP_MOBILE_LENGTH}
              />
              <span className="country_code">+966 | </span>
            </div>
            <div className="form_field password">
              <Input
                type={inputType}
                placeholder={t("REGISTER.enterNewPassword")}
                label={t("REGISTER.newPassword")}
                name="password"
                value={inputData?.password}
                onChange={changeHandler}
                error={error?.password}
                extraError={error?.passwordErr}
              />
              <span className="password_icons">{icon}</span>
            </div>

            <div className="button_wrap">
              <Button
                type={"button"}
                onClick={sendVerificationOtpHandler}
                ref={sendVerifyButtonLoader}
              >
                {t("REGISTER.createAccount")}
              </Button>
            </div>
            <p className="redirect_singUp">
              {`${t("REGISTER.alreadyHaveAccount")} `}
              <Link to="/login" className="blue">
                {t("REGISTER.login")}
              </Link>
            </p>
          </form>
        </div>
      </div>

      {/* otp verification for signup user */}
      {verificationModal && (
        <CustomModal
          show={verificationModal}
          handleClose={closeModal}
          // className={"otpModal signupOpt"}
          className={"otpModal"}
        >
          <OTPScreen
            type="signup"
            inputData={inputData}
            closeModal={closeModal}
            setInputData={setInputData}
          />
        </CustomModal>
      )}
    </>
  );
};

export default SignUp;
